import { DomainRule } from '../../types';

export interface StartDateRequiredRuleDto {
  startDate?: Date;
}

export const StartDateRequiredRuleKey = 'startDateRequiredRule';

/**
 * A split test will always require a start date. This is used for reporting purposes.
 *
 * @param triggerSettings
 * @returns 'fail', with an error message, if no messages are chosen. 'pass' if any are set.
 */
export const StartDateRequiredRule = (dto: StartDateRequiredRuleDto): DomainRule => {
  if (!dto.startDate) {
    return {
      result: 'fail',
      ruleKey: StartDateRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
